import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderOpenSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.613a1 1 0 0 0 .948-.684l1.388-3A1 1 0 0 0 11 5h-1ZM4 3v1h5v1H4.677a1 1 0 0 0-.928.629L2.4 9H2V3h2Z"
    />
  </svg>
);
export default IconFolderOpenSizeXs;
